// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.upload-photo-man{
  background-image: url('Illustration.svg');
  width: 156px;
  height: 175px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  fill: #F9F7F3;
  flex-shrink: 0;
  background-repeat: no-repeat;
  background-size: contain;
  margin: 0 auto;
  display: block;
}

.helpful-container{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  min-width:345px;
}

.helpful-tips-box {
  background-color: #F7F0E4;
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: left;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;
}

.helpful-tip-header-text{
  color: #212121;
  font-family: "Mecherle Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 21px;
  text-align:left;
  margin-bottom: 0px;
}

.which-photo-bullets{
  color: #212121;
  font-family: "Mecherle Sans";
  font-size: 15.065px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.which-photo-bullets-grey {
  color: #767676;
  font-family: "Mecherle Sans";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}
.helpful-tip-bullets{
  font-family: "Mecherle Sans";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  width: 152px;
  margin-left:-13px;
}
.bullet-box{
  color: #212121;
  font-family: "Mecherle Sans";
  font-size: 15.065px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  align-self: stretch;
}
.photo-tips-text {
  color: #212121;
  font-family: "Mecherle Sans";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

.photo-tips-header-box {
  display: flex;
  flex-direction: column;
  align-items: left;
  /* justify-content: center; */
  width: 345px;

  height:auto;


}
.helpful-content{
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: left;
  gap: 16px;
  width: 345px;
  height:auto;
}
.button-box{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
}
#big-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 375px;
  padding: 32px 15px 0px 15px;

  gap: 32px;
}
`, "",{"version":3,"sources":["webpack://./projects/lossreporting-library/src/lib/damage-details/damage-photos-helpful-tips/damage-photos-helpful-tips.component.css"],"names":[],"mappings":";AACA;EACE,yCAA2D;EAC3D,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,+BAA+B;EAC/B,aAAa;EACb,cAAc;EACd,4BAA4B;EAC5B,wBAAwB;EACxB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,6BAA6B;EAC7B,gCAAgC;EAChC,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;;EAEZ,WAAW;;;AAGb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,iBAAiB;EACjB,SAAS;EACT,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;;EAE3B,SAAS;AACX","sourcesContent":["\n.upload-photo-man{\n  background-image: url(../../../assets/img/Illustration.svg);\n  width: 156px;\n  height: 175px;\n  border-top-left-radius: 20px;\n  border-bottom-left-radius: 20px;\n  fill: #F9F7F3;\n  flex-shrink: 0;\n  background-repeat: no-repeat;\n  background-size: contain;\n  margin: 0 auto;\n  display: block;\n}\n\n.helpful-container{\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  min-width:345px;\n}\n\n.helpful-tips-box {\n  background-color: #F7F0E4;\n  display: flex;\n  padding: 24px;\n  flex-direction: column;\n  align-items: left;\n  border-top-right-radius: 20px;\n  border-bottom-right-radius: 20px;\n  gap: 16px;\n  flex: 1 0 0;\n  align-self: stretch;\n}\n\n.helpful-tip-header-text{\n  color: #212121;\n  font-family: \"Mecherle Sans\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 21px;\n  text-align:left;\n  margin-bottom: 0px;\n}\n\n.which-photo-bullets{\n  color: #212121;\n  font-family: \"Mecherle Sans\";\n  font-size: 15.065px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.which-photo-bullets-grey {\n  color: #767676;\n  font-family: \"Mecherle Sans\";\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n}\n.helpful-tip-bullets{\n  font-family: \"Mecherle Sans\";\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  width: 152px;\n  margin-left:-13px;\n}\n.bullet-box{\n  color: #212121;\n  font-family: \"Mecherle Sans\";\n  font-size: 15.065px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px;\n  align-self: stretch;\n}\n.photo-tips-text {\n  color: #212121;\n  font-family: \"Mecherle Sans\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n}\n\n.photo-tips-header-box {\n  display: flex;\n  flex-direction: column;\n  align-items: left;\n  /* justify-content: center; */\n  width: 345px;\n\n  height:auto;\n\n\n}\n.helpful-content{\n  display: flex;\n  flex-direction: column;\n  /* justify-content: center; */\n  align-items: left;\n  gap: 16px;\n  width: 345px;\n  height:auto;\n}\n.button-box{\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 16px;\n}\n#big-box {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-width: 375px;\n  padding: 32px 15px 0px 15px;\n\n  gap: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
